import styled from "styled-components";
export const CircularsContainer = styled.div`
  background-color: #b4b4b4;
  background-position: top;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding: 130px 0;
  height: 100%;
  min-height: 70vh;
  margin-bottom: -16px;
  text-align: center;
  color: #fff;

  h1 {
    color: #fff;
  }

  .notice {
    border-top: solid #21201f 1px;
    border-bottom: solid #21201f 1px;
    font-size: 24px;
    margin: 32px auto;
    padding: 16px 0;
    display: table;
  }

  .items {
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding: 32px;

    .item {
      background: #fff;
      margin: 14px;
      padding: 12px 8px;
      border-radius: 12px;
      text-align: right;
      color: #000;
    }
  }
`;
